import { IconName } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import { Alert, Button } from 'react-bootstrap'
import Toast from 'react-bootstrap/Toast'
import { toast, Slide } from 'react-toastify'

const ToastMessage: React.FC<{ message: string | React.ReactNode }> = ({
    message,
}) => (
    <Toast bg="light">
        <Toast.Header className="d-flex justify-content-end"></Toast.Header>
        <Toast.Body>{message}</Toast.Body>
    </Toast>
)

const AlertMessage: React.FC<{ variant: string; message: string }> = (
    props
) => (
    <Alert variant={props.variant} dismissible>
        {props.message}
    </Alert>
)

function triggerToast(message: any, autoClose: false | number = 3000) {
    toast(<ToastMessage message={message} />, {
        position: 'top-right', // top-right, top-center, top-left, bottom-right, bottom-center, bottom-left
        autoClose: autoClose,
        hideProgressBar: true, // out of scope
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: false, // setting to false as we are using the Bootstrap button
        transition: Slide, // Slide, Zoom
    })
}

function triggerAlert(
    variant: string,
    message: string,
    autoClose: false | number = 3000,
    toastId: string | undefined = undefined
) {
    toast(<AlertMessage variant={variant} message={message} />, {
        position: 'top-center', // top-right, top-center, top-left, bottom-right, bottom-center, bottom-left
        autoClose: autoClose,
        hideProgressBar: true, // out of scope
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        closeButton: false, // setting to false as we are using the Bootstrap button
        transition: Slide, // Slide, Zoom
        toastId: toastId,
    })
}

const HintMessage: React.FC<{
    variant?: string
    btnVariant?: string
    message: string | JSX.Element
    icon?: IconName
}> = (props) => {
    const [show, setShow] = useState<boolean>(false)
    return (
        <>
            <Button
                variant={props.btnVariant || 'light'}
                size="sm"
                onClick={() => setShow(!show)}
                className="ms-3"
            >
                <FontAwesomeIcon icon={['fas', props.icon || 'info-circle']} />
            </Button>
            <Alert
                variant={props.variant || 'info'}
                dismissible
                show={show}
                onClose={() => setShow(false)}
                className="small mt-3"
            >
                {props.message}
            </Alert>
        </>
    )
}

export { triggerToast, triggerAlert, HintMessage }
